import React from 'react';
import './TeamProgress.css';

function TeamProgress({ participants, totalPieces, piecesPerSection }) {
  // Sort participants by pieces placed (descending)
  const sortedParticipants = [...participants].sort(
    (a, b) => (b.piecesPlaced || 0) - (a.piecesPlaced || 0)
  );

  // Get medal emoji based on rank
  const getMedal = (index) => {
    switch (index) {
      case 0:
        return '🥇';
      case 1:
        return '🥈';
      case 2:
        return '🥉';
      default:
        return `#${index + 1}`;
    }
  };

  // Calculate section progress
  const getSectionProgress = (participant) => {
    if (participant.section === null || participant.section === undefined) {
      return 0;
    }
    return Math.min(
      100,
      Math.round(((participant.piecesPlaced || 0) / piecesPerSection) * 100)
    );
  };

  return (
    <div className="team-progress">
      <h3>🏆 Leaderboard</h3>

      {sortedParticipants.length === 0 ? (
        <div className="no-participants">
          <p>No puzzlers yet. Invite some friends!</p>
        </div>
      ) : (
        <div className="leaderboard">
          {sortedParticipants.map((participant, index) => {
            const progress = getSectionProgress(participant);

            return (
              <div
                key={participant.odId || index}
                className={`leaderboard-item ${index < 3 ? 'top-three' : ''}`}
              >
                <div className="rank">{getMedal(index)}</div>

                <div className="player-info">
                  <div className="player-name">
                    {participant.name}
                    {participant.section !== null &&
                      participant.section !== undefined && (
                        <span className="player-section">
                          Section {participant.section + 1}
                        </span>
                      )}
                  </div>

                  {participant.section !== null &&
                    participant.section !== undefined && (
                      <div className="player-progress-bar">
                        <div
                          className="player-progress-fill"
                          style={{ width: `${progress}%` }}
                        />
                      </div>
                    )}
                </div>

                <div className="player-stats">
                  <span className="pieces-count">
                    {participant.piecesPlaced || 0}
                  </span>
                  <span className="pieces-label">pieces</span>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* Team Stats */}
      <div className="team-stats">
        <div className="team-stat">
          <span className="team-stat-icon">👥</span>
          <span className="team-stat-value">{participants.length}</span>
          <span className="team-stat-label">Puzzlers</span>
        </div>
        <div className="team-stat">
          <span className="team-stat-icon">🧩</span>
          <span className="team-stat-value">
            {participants.reduce((sum, p) => sum + (p.piecesPlaced || 0), 0)}
          </span>
          <span className="team-stat-label">Total Placed</span>
        </div>
        <div className="team-stat">
          <span className="team-stat-icon">📦</span>
          <span className="team-stat-value">
            {
              participants.filter(
                (p) => p.section !== null && p.section !== undefined
              ).length
            }
          </span>
          <span className="team-stat-label">Sections Claimed</span>
        </div>
      </div>
    </div>
  );
}

export default TeamProgress;
